import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import MenuPartProduct from 'PMT/entities/menu/MenuPartProduct';
import Product from 'PMT/entities/menu/Product';

class MenuPartProductView extends Component {

  static propTypes = {
    product: PropTypes.instanceOf(Product).isRequired,

    menuPartProduct: PropTypes.instanceOf(MenuPartProduct).isRequired,

    currencyCode: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.product.equals(this.props.product);
  }

  get product(): Product {
    return this.props.product;
  }

  get menuPartProduct(): MenuPartProduct {
    return this.props.menuPartProduct;
  }

  onDisplayDetail = () => {
    RouteAction.presentProductEdit(this.props.product);
  };

  render() {
    return (
      <tr className="menu_part_product_view">
        <td
          className="col-xs-6 pointer link-hover"
          onClick={this.onDisplayDetail}
        >
          {this.product.name}
        </td>
        <td className="col-xs-1">
          (+{CurrencyUtils.formatPriceWithCurrency(
            this.menuPartProduct.additionalPrice, this.props.currencyCode)})
        </td>
      </tr>
    );
  }

}

export default MenuPartProductView;
